import math from "mathjs";
import {filtersService} from "../builder/filters/filters";

export class Diet {
    nutrients = [];
    adjustments = [];
    enddata = [];
    adjustment_values = [];

    calculate(enddata, minmax) {
        if(!enddata) {
            return '';
        }

        let formula = enddata['parsed_' + minmax];

        let expression = formula
            .replace(/(#|\$)([0-9]+)/g, (match, type, key) => {
                let value;

                switch (type) {
                    case '#':
                        if(this.nutrients[key] !== undefined) {
                            value = this.nutrients[key].pivot['value_' + minmax];
                        }
                        break;
                    case '$':
                        if(this.adjustments[key] !== undefined) {
                            value = this.adjustment_values[key];

                            let data = this.adjustments[key].pivot.data;

                            if(data instanceof Array && this.adjustments[key].type == 1) {
                                value = data[value];
                            }
                        }
                        break;
                }

                if(value === null || value === undefined || value === '') {
                    // console.log("Missing " + type + " value " + key);
                    return undefined;
                }

                return value;
            });

        if(expression.indexOf('undefined') >= 0) {
            return '';
        }

        let value = math.eval(expression);

        if(value === undefined) {
            return value;
        }

        if(value === 0) {
            return '';
        }

        let decimals = this.nutrients[enddata.nutrient_id].decimals;

        // Just return unit
        if(!filtersService.weight_unit && !this.nutrients[enddata.nutrient_id].type) {
            return value.toFixed(decimals);
        }

        let unit_id = this.nutrients[enddata.nutrient_id].unit_id;
        let multiplier = unit_weight_factor[unit_id];

        // No percentage multiplier found
        if(multiplier === null) {
            return value.toFixed(decimals);
        }

        // Return percentage
        return (value * multiplier).toFixed(decimals);
    }

    constructor(nutrients, grouped_adjustments, enddata, diet) {
        this.id = diet.id;
        this.title = diet.title;

        // flatten
        let adjustments = [].concat(...grouped_adjustments.map(v => v.items));

        nutrients.forEach((nut) => {
            this.nutrients[nut.id] = nut;
        });

        adjustments.forEach((adj) => {
            this.adjustments[adj.id] = adj;
        });

        enddata.forEach((v) => {
            this.enddata[v.nutrient_id] = v;
        });

        this.adjustment_values = this.adjustments.map(v => v.data && v.data.def !== undefined ? v.data.def : null);
    }

    getNutrientMin(nutrient_id) {
        return this.calculate(
            this.enddata[nutrient_id], 'min'
        );
    }

    getNutrientMax(nutrient_id) {
        return this.calculate(
            this.enddata[nutrient_id], 'max'
        );
    }
}
